/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-25 14:38:47
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-17 10:46:29
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/components/myPromonteGoods/columns.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const goodsInfo = {
	key: '',
	label: '商品信息',
	type: () => import('./tableCells/goodsInfo.vue'),
	minWidth: '290',
	fixed: 'left',
};

const goodsResources = {
    key: '',
	label: '商品来源',
	type: () => import('./tableCells/goodsResources.vue'),
	minWidth: '180',
}
const goodsStatus = {
    key: '',
	label: '状态',
	type: () => import('./tableCells/goodsStatus.vue'),
	minWidth: '180',
}
const goodsMechanism = {
	key:'',
	label: '报名机制',
	type: () => import('./tableCells/goodsMechanism.vue'),
	minWidth: '180',
}
const goodsActivity = {
	key: '',
	label: '报名活动',
	type:() => import('./tableCells/goodsActivity.vue'),
	minWidth: '300'
}
const goodsData = {
	key: '',
	label: '数据',
	type:() => import('./tableCells/goodsData.vue'),
	minWidth: '180',
}
const goodsContacts = {
	key: '',
	label: '联系人',
	type:() => import('./tableCells/goodsContacts.vue'),
	minWidth: '180',
}
export const columns = [goodsInfo,goodsResources,goodsStatus,goodsMechanism,goodsActivity,goodsData,goodsContacts];
